import React from "react";
import moment from "moment";
import { Tag } from "antd";
import { NoDecimalFormat, SingleDecimalFormat, TwoDecimalFormat } from "@components/Format";
import { useSelector } from "react-redux";
import { useSmartNavigate } from "@/hooks/use-smart-navigate";
import { buildFacilityPath, getFacilityContext } from "@/utils/route-context";

const formatDate = (value) => {
  if (!value) return "-";
  const parsed = moment(value);
  return parsed.isValid() ? parsed.format("YYYY-MM-DD") : value;
};

const formatServiceMonth = (value) => {
  if (!value) return "-";
  const parsed = moment(value);
  return parsed.isValid() ? parsed.format("YYYY-MM") : value;
};

const formatUsage = (value, unit) => {
  if (value == null || value === "") return "-";
  if (unit === "MMBtu") return TwoDecimalFormat(value);
  return NoDecimalFormat(value);
};

const formatCost = (value) => {
  if (value == null || value === "") return "-";
  return TwoDecimalFormat(value);
};

const formatAvgOat = (value) => {
  if (value == null || value === "") return "-";
  return SingleDecimalFormat(value);
};

const StatusTag = ({ certified }) => (
  <Tag color={certified ? "green" : "red"} className="utility-mobile-card-status-tag">
    {certified ? "Certified" : "Uncertified"}
  </Tag>
);

export const createUtilityMobileHeader = ({
  detailPathPrefix,
  usageUnit,
}) => {
  return function UtilityMobileHeader({ record }) {
    const { navigateAndCloseTabs } = useSmartNavigate();
    const facilityContext = useSelector((state) => getFacilityContext(state));

    const title = formatServiceMonth(record?.service_month);
    const usage = formatUsage(record?.usage, usageUnit);
    const modifiedDate = formatDate(record?.modified_date);
    const avgOat = formatAvgOat(record?.avgoat);
    const cost = formatCost(record?.costs);
    const certified = record?.is_eui_certified === true;

    const handleTitleClick = (e) => {
      e.stopPropagation();
      const nextPath = buildFacilityPath(`${detailPathPrefix}${record?.id}`, facilityContext);
      if (!nextPath) return;
      navigateAndCloseTabs(nextPath, {
        viewType: "facility",
        leafPrefix: `${detailPathPrefix}`,
      });
    };

    return (
      <div className="utility-mobile-card">
        <div className="utility-mobile-card-row utility-mobile-card-row-primary">
          <span
            className="utility-mobile-card-title utility-mobile-card-title-link"
            title={title || ""}
            onClick={handleTitleClick}
          >
            {title}
          </span>
          <span className="utility-mobile-card-usage" title={`${usage} ${usageUnit}`}>
            <span className="utility-mobile-card-value">{usage}</span>
            <span className="utility-mobile-card-unit">{usageUnit}</span>
          </span>
          <span className="utility-mobile-card-date" title={modifiedDate}>
            {modifiedDate}
          </span>
        </div>
        <div className="utility-mobile-card-row utility-mobile-card-row-secondary">
          <span className="utility-mobile-card-meta utility-mobile-card-meta-left">
            <span className="utility-mobile-card-meta-label">OAT</span>
            <span className="utility-mobile-card-meta-value">{avgOat}</span>
            <span className="utility-mobile-card-meta-suffix">{"\u00b0F"}</span>
          </span>
          <span className="utility-mobile-card-meta utility-mobile-card-meta-center">
            <span className="utility-mobile-card-meta-label">Cost</span>
            <span className="utility-mobile-card-meta-value">
              {cost === "-" ? "-" : `$${cost}`}
            </span>
          </span>
          <StatusTag certified={certified} />
        </div>
      </div>
    );
  };
};
